<template>
<ValidationObserver ref="observer">
  <form ref="edit_nota_jasa_bkl_form" @submit.prevent="updateNotaJasaBkl">
    <md-card>
      <!-- <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Edit Nota Jasa Bkl
        </h4>
      </md-card-header> -->
      <md-card-content>
        <div class="md-layout"> 
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            (Read) No. Nota Jasa Bkl
          </label> -->
          <div class="md-layout-item md-size-50 md-small-size-100">
            <validation-provider rules="notajasano" v-slot="{ errors }">
            <label for="">(Read) Nota Jasa No</label>
            <md-field class="md-invalid">
              <md-input v-model="nota_jasa_bkl_no" disabled required/>
              <validation-error
                :errors="apiValidationErrors.nota_jasa_bkl_no"
              />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        <!-- </div>

        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            (Read) Nota Jasa Bkl Date
          </label> -->
          <div class="md-layout-item md-size-50 md-small-size-100">
            <validation-provider rules="notajasadate" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">(Read) Nota Jasa Date</label>
              <md-input v-model="nota_jasa_bkl_datetime" disabled required/>
              <validation-error
                :errors="apiValidationErrors.nota_jasa_bkl_datetime"
              />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            (Read) PKB No
          </label> -->
          <div class="md-layout-item md-size-100 md-small-size-100">
            <validation-provider rules="pkbno" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">(Read) PKB No</label>
                <md-input
                  readonly
                  type="hidden"
                  v-model="nota_jasa_bkl_pkb_id"
                  required
                />
                <md-input readonly v-model="nota_jasa_bkl_pkb_no" />
                <validation-error
                  :errors="apiValidationErrors.nota_jasa_bkl_pkb_id"
                />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
            </validation-provider>
          </div>
        </div>

        
        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            Service
          </label> -->
          <div class="md-layout-item">
            <service-card
              :services="services"
              v-if="services.length != 0"
              ref="childServiceComponent"
              @data="dataService"
            />
          </div>
        </div>

        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:green">Diperiksa</span>
          </label> -->
          <!-- <div class="md-layout-item md-size-50 md-small-size-100">
            <validation-provider rules="diperiksa" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">Diperiksa</label>
              <md-select v-model="nota_jasa_bkl_diperiksa">
                <md-option
                  v-for="option in options_sa_list"
                  :key="option.value"
                  :value="option.id"
                  required
                >
                  {{ option.name }}
                </md-option>
              </md-select>
              <validation-error
                :errors="apiValidationErrors.nota_jasa_bkl_diperiksa"
              />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div> -->
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <label for="">Diperiksa</label>
              <md-input v-model="nota_jasa_bkl_diperiksa" disabled/>
            </md-field>
          </div>
        <!-- </div>
        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:green">Mengetahui</span>
          </label> -->
          <div class="md-layout-item md-size-50 md-small-size-100">
            <validation-provider rules="mengetahui" v-slot="{ errors }">
            <md-field class="md-invalid">
              <md-select v-model="nota_jasa_bkl_mengetahui" required>
                <md-option
                  v-for="option in options_manager_list"
                  :key="option.value"
                  :value="option.id"
                >
                  {{ option.name }}
                </md-option>
              </md-select>
              <validation-error
                :errors="apiValidationErrors.nota_jasa_bkl_mengetahui"
              />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        </div>
      </md-card-content>

      <md-card-actions>
        <md-button class="md-info md-dense" @click="editConfirmation">
          Update
        </md-button>
        <md-button class="md-dense" @click="backtoList">
          Go to List
        </md-button>
      </md-card-actions>
    </md-card>
  </form>
</ValidationObserver>
</template>

<script>
import { ValidationError } from "@/components";
import {extend , ValidationObserver} from 'vee-validate';
import formMixin from "@/mixins/form-mixin";
import { required } from 'vee-validate/dist/rules';
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import Swal from "sweetalert2";
import ServiceCard from "@/pages/Dashboard/Workshop/NotaJasaBkl/ComponentForm/ServiceCard.vue";

Vue.use(VueSweetalert2);

extend('notajasano', {
  ...required,
  message: 'Nota Jasa No. field is required'
});
extend('notajasadate', {
  ...required,
  message: 'Nota Jasa Date field is required'
});

extend('pkbno', {
  ...required,
  message: 'PKB No. field is required'
});
extend('diperiksa', {
  ...required,
  message: 'Diperiksa field is required'
});
extend('mengetahui', {
  ...required,
  message: 'Mengetahui field is required'
});

export default {
  name: "edit-nota-jasa-bkl",

  components: { ValidationError, "service-card": ServiceCard, ValidationObserver },
  mixins: [formMixin],

  data: () => ({
    nota_jasa_bkl_no: null,
    nota_jasa_bkl_datetime: null,
    nota_jasa_bkl_pkb_id: null,
    nota_jasa_bkl_pkb_no: null,
    nota_jasa_bkl_diperiksa: null,
    nota_jasa_bkl_mengetahui: null,
    nota_jasa_bkl_total: null,
    options_sa_list: null,
    options_manager_list: null,
    services: [],
  }),

  created() {
    this.getNotaJasaBklData();
  },

  methods: {
    //kembali ke list
    backtoList() {
      this.$router.replace({ name: "List Nota Jasa Bkl" });
    },

    //ambil data yang di perlukan
    async getNotaJasaBklData() {
  
      //check apakah id di route ada
      if (this.$route.params.id) {
        //jika ada panggil data nota jasa berdasarkan id
        await this.$store.dispatch("workshop_nota_jasa_bkl/get", this.$route.params.id);
        this.nota_jasa_bkl = await this.$store.getters[
          "workshop_nota_jasa_bkl/nota_jasa_bkl"
        ];
        console.log( this.nota_jasa_bkl)
        this.nota_jasa_bkl_no = this.nota_jasa_bkl.nota_jasa_bkl_no;
        this.nota_jasa_bkl_datetime = this.nota_jasa_bkl.nota_jasa_bkl_datetime;
        this.nota_jasa_bkl_pkb_id = this.nota_jasa_bkl.nota_jasa_bkl_pkb_id;
        this.nota_jasa_bkl_mengetahui = this.nota_jasa_bkl.nota_jasa_bkl_mengetahui_name.id;

        //ambil dara pkb berdasarkan id pkb yang ada di nota jsa bkl
        await this.$store.dispatch("workshop_pkb/get", this.nota_jasa_bkl_pkb_id);
        var pkb = await this.$store.getters["workshop_pkb/pkb"];
        this.services = pkb.pkb_service;
        this.nota_jasa_bkl_pkb_no = pkb.pkb_no;
        this.nota_jasa_bkl_diperiksa = pkb.pkb_service_estimate.sa_name.name;


          //ambil list user sa
          // var query = {"filter":{role:'service_advisor',pool:pkb.pkb_service_estimate.service_estimate_pool_id}}
          // await this.$store.dispatch("users/list",query) 
          // this.options_sa_list = await this.$store.getters["users/list"]


            //ambil list user auto manager
            var query = {"filter":{role:'workshop_head',pool:pkb.pkb_service_estimate.service_estimate_pool_id}}
            await this.$store.dispatch("users/list",query)
          this.options_auto_manager_list = await this.$store.getters["users/list"]
      }
    },

    //edit konfirmasi
    async editConfirmation(id) {
      const isValid = await this.$refs.observer.validate();
      //check validasi input form
      if (!isValid) {
        return
      }
      Swal.fire({
        title: "Are you sure?",
        text: "The data will be edited!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Edit it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.updateNotaJasaBkl(id);
        }
      });
    },

    //update nota jasabkl
    async updateNotaJasaBkl() {
      //panggil fungsi getData di child page/service card
      this.$refs.childServiceComponent.getData();

      const data = {
        id: this.nota_jasa_bkl.id,
        type: "workshop_nota_jasa_bkls",
        nota_jasa_bkl_no: this.nota_jasa_bkl_no,
        nota_jasa_bkl_datetime: this.nota_jasa_bkl_datetime,
        nota_jasa_bkl_pkb_id: this.nota_jasa_bkl_pkb_id,
        nota_jasa_bkl_total: this.nota_jasa_bkl_total,
        nota_jasa_bkl_mengetahui: this.nota_jasa_bkl_mengetahui,
        // nota_jasa_bkl_diperiksa: this.nota_jasa_bkl_diperiksa,
      };

      try {
        //kirim data ke api
        await this.$store.dispatch("workshop_nota_jasa_bkl/update", data);
        //panggil alert succes
        await this.$store.dispatch(
          "alerts/success",
          "Nota Jasa Bkl data changed successfully."
        );
        //kembali ke list
        await this.$router.replace({ name: "List Nota Jasa Bkl" });
        //this.$refs['password_form'].reset()
      } catch (e) {
        //panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
        this.setApiValidation(e.response.data.errors);
      }
    },
    //set data yang diambil dari fungsi getData di child page/service card
    dataService(value) {
      console.log(value);
      this.nota_jasa_bkl_total = value;
    },
  },
};
</script>
